import template from './index.html'
function init (params) {
}

export default {
  name: 'box',
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/box/index.js